import styled from 'styled-components';
import { m, mb, mt, p, pr, px } from '@upgrade/react-components/Spacing/core';
import { UnderlinedLink } from '../common/styles';
import Image from '../common/Image';

export const Title = styled.div`
  font-weight: normal;
  font-size: ${({ theme }) => theme.typography.sizes.text.mobile.xl.fontSize};
  line-height: 100%;
  ${mt('3xl')};
  margin-bottom: 1.875rem;
  @media (min-width: ${props => props.theme.mediaSm}) {
    font-size: ${({ theme }) => theme.typography.sizes.headings.desktop.number_lg.fontSize};
  }
`;

export const TitleLight = styled.h2`
  text-transform: uppercase;
  font-weight: 300;
  letter-spacing: 0.625rem;
  font-size: ${({ theme }) => theme.typography.sizes.text.desktop.md.fontSize};
  margin-bottom: ${({ spaced }) => (spaced ? '4rem' : '1rem')};
  color: inherit;
`;

export const StyledOffice = styled.div`
  text-align: center;
  justify-content: center;
  padding: 0 1rem;
  position: relative;
  margin-bottom: ${({ moreInfoText }) => (moreInfoText ? '3rem' : '1rem')};
  @media (min-width: ${props => props.theme.mediaSm}) {
    ${m('none')};
    padding: 0 2rem;
    ${mb('md')};
  }
`;

export const AboutTextWrapper = styled.div`
  + p {
    font-weight: 400;
  }
  ul {
    list-style-type: none;
    padding-left: 0;
    li {
      font-weight: 500;
      font-size: ${({ theme }) => theme.typography.sizes.headings.mobile.lg.fontSize};
    }
  }
`;

export const LogoContainer = styled.div`
  height: 10rem;
  position: relative;
  ${mb('md')};
`;

export const OfficeLink = styled.a`
  text-decoration: none;
  &:focus,
  &:hover {
    text-decoration: none;
  }
`;

export const OurGoalContainer = styled.div`
  text-align: center;
  color: ${props => props.theme.palette.contentReverse};
  background-color: ${props => props.theme.palette.actionablePrimary};
  padding: 4rem 1.25rem;

  @media (min-width: ${props => props.theme.mediaMd}) {
    padding: 4rem 11rem;

    p {
      font-size: ${({ theme }) => theme.typography.sizes.headings.desktop.md.fontSize};
      line-height: 123%;
    }
  }
`;

export const StyledImage = styled(Image)`
  max-width: 100%;
  height: auto;
  width: 15rem;
  @media (min-width: ${props => props.theme.mediaSm}) {
    ${pr('xl')};
    width: auto;
  }
`;

export const StyledUnderlinedLink = styled(UnderlinedLink)``;

export const AwardImage = styled(Image)`
  max-width: 120px;
  max-height: 120px;
  object-fit: contain;
`;

export const StyledCityText = styled.div`
  font-size: ${({ theme }) => theme.typography.sizes.headings.desktop.xs.fontSize};
  font-weight: ${({ weight }) => weight};
  color: ${({ theme }) => theme.palette.actionablePrimary};
  margin-bottom: 1rem;
`;

export const StyledOfficeTypeText = styled.div`
  font-size: ${({ theme }) => theme.typography.sizes.headings.desktop.xs.fontSize};
  font-weight: ${({ weight }) => weight};
  margin-bottom: 1rem;
`;

export const OfficesContainer = styled.div`
  max-width: 68rem;
  margin: 0 auto;
  ${mt('3xl')};

  @media (min-width: ${props => props.theme.mediaMd}) {
    ${mt('none')};
    ${px('sm')}
  }
`;

export const OfficeCard = styled.div`
  border-radius: 0.4rem;
  max-width: 21rem;
  max-height: 23.5rem;
  margin: 1rem auto;
`;

export const OfficeText = styled.div`
  background-color: ${({ theme }) => theme.palette.contentReverse};
  ${p('md')};
  border-bottom-right-radius: 0.4rem;
  border-bottom-left-radius: 0.4rem;
  position: relative;
`;

export const AllOfficesImageContainer = styled(OfficeCard)`
  background-color: ${({ theme }) => theme.palette.contentReverse};
  position: relative;
  width: 100%;
  min-height: 23.5rem;

  > img {
    position: absolute;
    top: -63px;
    left: -1px;
    height: auto;
    width: 105%;
  }
`;
